import MissionDirector from './MissionDirector';

export const getMission = (id) => {
  const missionBuilder = MissionDirector.getBuilder();
  const mission = missionBuilder.buildMission(id);
  console.log(JSON.stringify(mission, null, 2));

  return mission;
}



// WEBPACK FOOTER //
// ./src/components/admin/Help/Builder/index.js